import { Box, FormControl, FormHelperText, styled } from "@mui/material";
import * as React from "react";
import { convertToTranslationKeys, ValidationError } from "../../../services/validator";
import { t } from "i18next";
import { grey } from "@mui/material/colors";

const OuterContainer = styled(Box)(({theme}) => ({
    position: 'relative',
    display: 'flex',
    padding: theme.spacing(1.9),
    borderRadius: 4,
    border: `solid 1px`,
    borderColor: grey[400],

    '&:hover': {
        borderColor: grey[900],
    },
}));

const Label = styled(Box)(({theme}) => ({
    top: 0,
    position: 'absolute',
    marginTop: -9,
    marginLeft: -5,
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: 'white',
    fontSize: 12,
    color: grey[900],
}));

const MainContainer = styled(Box)(({theme}) => ({
    flexGrow: 1,
}));

const EndAdornmentContainer = styled(Box)(({theme}) => ({
    marginLeft: theme.spacing(1),
}));

interface IOutlinedContainerProps {
    children: React.ReactNode;
    label: string;
    errors?: ValidationError[];
    endAdornment?: React.ReactNode;
    helperText?: React.ReactNode;
}

export const OutlinedContainer = ({ children, label, errors, endAdornment, helperText }: IOutlinedContainerProps) => (
    <FormControl fullWidth>
        <OuterContainer>
            <Label>{label}</Label>

            <MainContainer>
                {children}
            </MainContainer>

            {!!endAdornment && (
                <EndAdornmentContainer>
                    {endAdornment}
                </EndAdornmentContainer>
            )}
        </OuterContainer>

        {!!helperText && (
            <FormHelperText>
                {helperText}
            </FormHelperText>
        )}

        {!!errors && !!errors.length &&
            <FormHelperText error>
                {convertToTranslationKeys(errors).map(e => t(e)).join(', ')}
            </FormHelperText>
        }
    </FormControl>
);
